/* eslint-disable no-console */

import { useLayoutEffect } from 'react';

import { useOnceImmediately } from '../hooks';
import { type Experience, type ExperienceMark } from './constants';
import { useExperienceTracker } from './context';

export function useExperienceStart(experienceName: Experience, customStartTime?: number): void {
	const experienceTracker = useExperienceTracker();
	useOnceImmediately(() => experienceTracker.start(experienceName, customStartTime));
}

export function useExperienceSuccess(experience: Experience, attributes?: object): void {
	const experienceTracker = useExperienceTracker();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	useLayoutEffect(() => experienceTracker.success(experience, attributes), []);
}

export function useExperienceRenderAndMountMark(mark: ExperienceMark): void {
	const experienceTracker = useExperienceTracker();

	useOnceImmediately(() => experienceTracker.markStart(mark));
	// eslint-disable-next-line react-hooks/exhaustive-deps
	useLayoutEffect(() => experienceTracker.markEnd(mark), []);
}
